import { DOCUMENT } from '@angular/common';
import { inject, Injectable, signal } from '@angular/core';

/**
 * Tracks the current portal route the widget is rendered on.
 *
 * The host drives this explicitly via {@link setPath} (wired through
 * `AppComponent`'s `currentPath` input, updated on every host navigation).
 * The initial value is read from `window.location.pathname` so the widget
 * still resolves a context before the host pushes the first route.
 */
@Injectable({ providedIn: 'root' })
export class PageContextService {
  readonly #document = inject(DOCUMENT);

  readonly #currentPath = signal<string | null>(this.#readBrowserPath());
  readonly currentPath = this.#currentPath.asReadonly();

  setPath(path: string | null): void {
    this.#currentPath.set(path);
  }

  #readBrowserPath(): string | null {
    return this.#document.defaultView?.location.pathname ?? null;
  }
}
